var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"logo-wrapper",attrs:{"href":"https://www.makietainteraktywna.pl/","target":"_blank"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo-yslab.svg"),"alt":"YSLAB logo","draggable":"false"}})])
}]

export { render, staticRenderFns }